export default "<button class=\"btn btn-info mb-2 \" (click)=\"searchfn.emit()\"><span  class=\"fa fa-search mr-1\" aria-hidden=\"true\"></span>Search</button>"